import './styles.css'

import { format, isToday, isYesterday } from 'date-fns'
import isSameDay from 'date-fns/isSameDay'
import { useMemo } from 'react'
import StickyList from 'stickylist'

import { TransactionItemMobile } from '../transaction-item/transaction-item-mobile'
import Icon from '../transcation-list/icons/truck.svg'
interface DateListProps {
    items?: any[]
}

export function DateList({ items = [] }: DateListProps) {
    const data = useMemo(() => {
        const item = items?.[0]

        let today = false
        let yesterday = false

        const createHeader = (
            date: Date,
            today: boolean,
            yesterday: boolean,
        ) => {
            if (!today && isToday(date)) {
                today = true
                return 'Today'
            }
            if (!yesterday && isYesterday(date)) {
                yesterday = true
                return 'Yesterday'
            }
            return format(date, 'dd MMM')
        }

        if (item) {
            const chronologicalData = []

            let auxDate = new Date(item.date)
            let auxItems = []

            for (let i = 0; i < items.length; i++) {
                const newItem = items[i]
                const date = new Date(newItem.date)

                if (isSameDay(date, auxDate)) {
                    auxItems.push(newItem)
                } else {
                    chronologicalData.push({
                        header: createHeader(auxDate, today, yesterday),
                        key: format(auxDate, 'dd/MM/yyyy'),
                        date: auxDate,
                        items: [...auxItems].map((t, idx) => (
                            <TransactionItemMobile
                                {...t}
                                key={`transaction-${idx}`}
                                description={
                                    t.__typename === 'CryptoTransaction'
                                        ? t.name
                                        : t.description
                                }
                                icon={
                                    t.__typename === 'CryptoTransaction' ? (
                                        t.icon
                                    ) : (
                                        <div className='box-border flex items-center justify-center w-8 h-8 p-2 mr-4 bg-black rounded-full'>
                                            <img
                                                className='filter invert'
                                                src={Icon}
                                                alt={'truck_icon'}
                                            />
                                        </div>
                                    )
                                }
                            />
                        )),
                    })

                    auxItems = [newItem]
                    auxDate = date
                }
            }

            chronologicalData.push({
                header: createHeader(auxDate, today, yesterday),
                key: format(auxDate, 'dd/MM/yyyy'),
                date: auxDate,
                items: [...auxItems].map((t, idx) => (
                    <TransactionItemMobile
                        {...t}
                        key={`transaction-${idx}`}
                        description={
                            t.__typename === 'CryptoTransaction'
                                ? t.name
                                : t.description
                        }
                        icon={
                            t.__typename === 'CryptoTransaction' ? (
                                t.icon
                            ) : (
                                <div className='box-border flex items-center justify-center w-8 h-8 p-2 mr-4 bg-black rounded-full'>
                                    <img
                                        className='filter invert'
                                        src={Icon}
                                        alt={'truck_icon'}
                                    />
                                </div>
                            )
                        }
                    />
                )),
            })

            return chronologicalData
        }
        return []
    }, [items])

    return data.length ? (
        <StickyList data={data} className='w-full h-full' />
    ) : (
        <div></div>
    )
}
